import { useEffect, useState } from 'react';
import { Modal } from 'react-bootstrap';
import Select from "react-select";
import api, { isCanceled } from '../lib/api';
import useNotify from '../hooks/useNotify';
import { ALERT_TYPES } from './AddNewAlert';

const AddNewNotification = ({ show, setShow, formData, action, setFormData, setNotification, onSaved }) => {
    const [loader, setLoader] = useState(false);
    const [users, setUsers] = useState([]);
    const notify = useNotify(setNotification);

    const isAdd = action === "add";
    const close = () => setShow(false);

    useEffect(() => {
        const controller = new AbortController();

        api.get('/users', {
            params: { page: 1, limit: 1000, keyword: "", sort_by: "id", sort_order: "DESC", eligible_to_bid: "", blocked: "", admin_id: "", active: "" },
            signal: controller.signal,
        })
            .then((res) => {
                const data = (res.data.data || []).map((u) => ({ label: u.username, value: u.username }));
                setUsers(data);
            })
            .catch((err) => {
                if (isCanceled(err)) return;
                setUsers([]);
                notify.error(err, "Could not load the user list.");
            });

        return () => controller.abort();
    }, [notify]);

    const submit = (e) => {
        e.preventDefault();

        const selected = formData.users || [];
        if (selected.length === 0) {
            notify.error(null, "Select at least one recipient.");
            return;
        }

        setLoader(true);
        const payload = { ...formData, users: selected.map((p) => p.value) };
        const request = isAdd
            ? api.post('/notifications', payload)
            : api.put(`/notifications/${formData.id}`, payload);

        request
            .then((res) => {
                notify.success(res.data.message.en);
                close();
                if (onSaved) onSaved();
            })
            .catch((err) => notify.error(err))
            .finally(() => setLoader(false));
    };

    return (
        <Modal show={show} onHide={close} size='lg' centered>
            <Modal.Header closeButton><h2 className="modal-title-text">{isAdd ? "Add New Notification" : "Edit Notification"}</h2></Modal.Header>
            <Modal.Body>
                <div className='container'>
                    <form className='row' onSubmit={submit}>
                        <div className="col-md-6 mb-4">
                            <div className="form-group">
                                <label htmlFor="notification-title">Title*</label>
                                <input id="notification-title" required placeholder="Enter notification title" type="text" className="form-control" name="title" value={formData.title ?? ""} onChange={(e) => setFormData((prev) => ({ ...prev, title: e.target.value }))} />
                            </div>
                        </div>
                        <div className="col-md-6 mb-4">
                            <div className="form-group">
                                <label htmlFor="notification-type">Notification type*</label>
                                <select id="notification-type" required className="form-control" name="alert_type" value={formData.alert_type ?? ""} onChange={(e) => setFormData((prev) => ({ ...prev, alert_type: e.target.value }))}>
                                    <option value="">Select Notification Type</option>
                                    {ALERT_TYPES.map((type) => <option key={type.value} value={type.value}>{type.label}</option>)}
                                </select>
                            </div>
                        </div>
                        <div className='col-md-12 mb-4'>
                            <div className="form-group">
                                {/* The recipients picker previously had no label
                                    at all. */}
                                <label htmlFor="notification-users">Recipients*</label>
                                <Select
                                    inputId="notification-users"
                                    isMulti
                                    className="no-padding"
                                    classNamePrefix="rs"
                                    options={users}
                                    value={formData.users ?? []}
                                    placeholder="Select users..."
                                    onChange={(value) => setFormData((prev) => ({ ...prev, users: [...(value || [])] }))}
                                />
                            </div>
                        </div>
                        <div className="col-md-12 mb-4">
                            <div className="form-group">
                                <label htmlFor="notification-message">Message*</label>
                                <textarea style={{ height: "100px" }} id="notification-message" required placeholder="Enter message" className="form-control" name="html" value={formData.html ?? ""} onChange={(e) => setFormData((prev) => ({ ...prev, html: e.target.value }))} />
                            </div>
                        </div>
                        <div className="modal-action-buttons">
                            <button type="submit" disabled={loader} className="submit-modal-form-btn">{loader ? <div className="button-loader"></div> : (isAdd ? "Submit" : "Save")}</button>
                            <button type="button" onClick={close} className="cancel-modal-form-btn">Cancel</button>
                        </div>
                    </form>
                </div>
            </Modal.Body>
        </Modal>
    )
}

export default AddNewNotification
